import { useState } from "react";
import { post } from "../networking/RequestService";

function useMarkCainNotificationAsRead() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // markAsAllRead: true marks every unread notification of the user, so notificationId is
    // not needed for it.
    const markAsRead = async (notificationId, { markAsAllRead = false } = {}) => {
        setLoading(true);
        setError(null);
        try {
            const res = await post({ fn: "markCainNotificationAsRead", notificationId, markAsAllRead });
            return res.data;
        } catch (err) {
            setError(err.response?.data?.text || err.message);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { markAsRead, loading, error };
}

export default useMarkCainNotificationAsRead;
